import { ArrowRight } from "lucide-react";
import { wasteServices } from "@/content/wasteServices";

const ServicesSection = () => (
  <section id="services" className="scroll-mt-28 bg-white py-16 md:py-24">
    <div className="container">
      <h2 className="text-3xl md:text-4xl font-black text-dark text-center mb-4">
        What We Remove
      </h2>
      <p className="text-center text-muted-foreground mb-14 max-w-lg mx-auto">
        From a few unwanted items to complete property clear-outs.
      </p>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {wasteServices.map((s) => (
          <a
            key={s.slug}
            href={`/${s.slug}`}
            aria-label={`${s.cardTitle}, view service page`}
            className="group bg-card rounded-xl p-7 hover:shadow-lg hover:-translate-y-0.5 transition-all border border-transparent hover:border-orange/40 hover:bg-orange-soft block"
          >
            <div className="w-12 h-12 bg-yellow/15 rounded-full flex items-center justify-center mb-5">
              <s.icon className="w-6 h-6 text-dark group-hover:text-orange transition-colors" />
            </div>
            <h3 className="text-xl font-bold text-dark mb-2">{s.cardTitle}</h3>
            <p className="text-muted-foreground leading-relaxed">{s.cardDesc}</p>
            <span className="mt-4 inline-flex items-center gap-1 text-dark group-hover:text-orange transition-colors font-bold text-sm">
              Learn More
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </span>
          </a>
        ))}
      </div>
    </div>
  </section>
);

export default ServicesSection;
